import { DialogOverlay, DialogContent } from '../../node_modules/@reach/dialog/dist/reach-dialog.esm.js';
import styled from 'styled-components';
import { Text } from '../text/text.component.js';
import { addsOpacity } from '../../utils/color-manipulation.js';
import 'react';

const getWidth = (size) => {
    if (size === 'small') {
        return '400px';
    }
    else if (size === 'medium') {
        return '480px';
    }
    else if (size === 'large') {
        return '1024px';
    }
    else if (size === 'full-screen') {
        return '100%';
    }
};
const Overlay = styled(DialogOverlay) `
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background-color: ${props => addsOpacity({
    color: props.theme.colors.content.primary,
    opacity: props.theme.opacities.medium,
})};
`;
const Dialog = styled(DialogContent) `
  display: flex;
  flex-direction: column;
  border-radius: ${props => props.size === 'full-screen' ? 0 : props.theme.borderRadii.xLarge};
  background-color: ${props => props.theme.colors.background.primary};
  width: ${props => getWidth(props.size)};
  height: ${props => (props.size === 'full-screen' ? '100%' : 'auto')};
  overflow-y: auto;
  max-height: 100%;
`;
const StyledHeader = styled.div `
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  padding: 24px 32px;
`;
const Title = styled(Text) `
  flex-grow: 1;
  text-align: ${props => props.textAlign};
`;

export { Dialog, Overlay, StyledHeader, Title };
